/**
 * File Name          : access-control-role.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export enum ACCESS_CONTROL_ROLE {
    // non-system roles
    EVERYONE = 0,
    ENGINEER = 1,
    FACTORY = 2,

    // system roles (can only be activated internally by the device itself)
    SYSTEM = 0xAA,
    MAX_VALUE = FACTORY
}